export const selectDeviceTree = (state) => state.devices.tree;
